import { FindTheme } from 'components/theme/ThemeExtension';
import { defaultThemeCode } from 'constants/constants';
import { useEffect, useState } from 'react';
import AuthService from 'services/AuthService';
import { Theme } from 'styles/theme';

export const useTheme = (licensee: any) => {
  const [theme, setTheme] = useState<Theme>(FindTheme(localStorage.getItem('theme') || ''));

  const changeTheme = (theme: string) => {
    const favicon = document.getElementById('favicon') as HTMLLinkElement;
    if (favicon) {
      favicon.href = (theme?.toLowerCase() ?? defaultThemeCode.toLowerCase()) === 'au' ? 'favicon-au.ico' : 'favicon.ico';
    }
    setTheme(FindTheme(theme));
    localStorage.setItem('theme', theme);
  };

  useEffect(() => {
    const changeThemeByLicensee = () => {
      if (!AuthService.isLoggedin()) {
        setTheme(FindTheme(defaultThemeCode));
        localStorage.setItem('theme', defaultThemeCode);
        return;
      }
      const licenseeCode = (licensee ? licensee?.code?.toLowerCase() : localStorage.getItem('theme')) ?? defaultThemeCode;
      changeTheme(licenseeCode);
    };

    changeThemeByLicensee();
  }, [licensee]);

  return { theme, changeTheme };
};
